module.exports = __webpack_public_path__ + "fonts/payback_script.40737e0d.ttf";